import classNames from 'styles/utils/classNames';
import PlayerDiscoverCard from './PlayerDiscoverCard';
import { exploreData } from './data';

const PlayerDiscover = ({
  borderBottom = true,
  className,
}: {
  borderBottom?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        'container mx-auto mt-[1.6rem]  border-color-bg-input-lightmode-primary pb-[4.5rem] dark:border-color-bg-input-darkmode-primary max-sm:px-4 max-sm:pb-ds-xl',
        className,
        borderBottom && 'border-b',
      )}
    >
      <h3 className="typography-product-subheading mb-5 max-sm:mb-3">Discover</h3>

      <div className="grid grid-cols-4 gap-x-ds-xl gap-y-ds-3xl max-xl:grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 max-sm:gap-y-ds-md">
        {exploreData.map((card) => (
          <PlayerDiscoverCard {...card} key={card.title} />
        ))}
      </div>
    </div>
  );
};

export default PlayerDiscover;
